/* src/ui/windows/travelWindow.ts — go anywhere in Australia.
 *
 * A list of real cities; clicking one jumps the world there. Rows carry their destination in
 * data attributes and fire through the root dispatcher (`travel:go`, registered once in
 * main.ts) — N rows cost zero listeners, the same contract every other window keeps. Whether
 * a destination is already surveyed is deliberately not shown here: the honest answer lives
 * on the map itself, where un-surveyed ground visibly fills in as the crew reports back.
 */

import { AU_CITIES } from '../../core/cities.ts';
import { el } from '../dom.ts';
import type { WindowManager } from './windowChrome.ts';

export function openTravelWindow(windows: WindowManager): void {
  const win = windows.open({ id: 'travel', title: 'Travel', width: 320 });

  const rows = AU_CITIES.map((city) =>
    el(
      'button',
      {
        class: 'gf-travel-row',
        attrs: { type: 'button' },
        data: {
          action: 'travel:go',
          lon: String(city.lon),
          lat: String(city.lat),
          city: city.name,
        },
      },
      el('span', { class: 'gf-travel-name' }, city.name),
      el('span', { class: 'gf-travel-state' }, city.state),
    ),
  );

  win.body.replaceChildren(
    el(
      'p',
      { class: 'gf-travel-hint' },
      'Anywhere you go gets surveyed and becomes buyable. New areas take the crew a few minutes.',
    ),
    el('div', { class: 'gf-travel-list' }, ...rows),
  );
}
